import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    zIndex: 2,
    top: 0,
    width: '100%',
    display: 'flex',
    position: 'sticky',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    minHeight: theme.spacing(6.25),
    backgroundColor: theme.palette.alert.background,
    padding: theme.spacing(1.25, 2.5),
  },

  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  lineClampText: {
    paddingRight: theme.spacing(2.5),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
  },

  button: {
    '&.MuiButton-root': {
      color: 'white',
      lineHeight: 1.3,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      fontFamily: '"Noto Sans"',
      textTransform: 'uppercase',
      minHeight: theme.spacing(3.75),
      borderRadius: theme.spacing(0.4),
      padding: theme.spacing(0.625, 1.25),
    },
  },

  buttonText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));
